import { useState } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";

const GEO_URL = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const FIPS_TO_STATE = {
  "01": "AL", "02": "AK", "04": "AZ", "05": "AR", "06": "CA", "08": "CO", "09": "CT", "10": "DE",
  "11": "DC", "12": "FL", "13": "GA", "15": "HI", "16": "ID", "17": "IL", "18": "IN", "19": "IA",
  "20": "KS", "21": "KY", "22": "LA", "23": "ME", "24": "MD", "25": "MA", "26": "MI", "27": "MN",
  "28": "MS", "29": "MO", "30": "MT", "31": "NE", "32": "NV", "33": "NH", "34": "NJ", "35": "NM",
  "36": "NY", "37": "NC", "38": "ND", "39": "OH", "40": "OK", "41": "OR", "42": "PA", "44": "RI",
  "45": "SC", "46": "SD", "47": "TN", "48": "TX", "49": "UT", "50": "VT", "51": "VA", "53": "WA",
  "54": "WV", "55": "WI", "56": "WY",
};

export function USMap() {
  const [hovered, setHovered] = useState(null);
  return (
    <div className="relative" data-testid="us-map">
      <ComposableMap projection="geoAlbersUsa" className="w-full h-auto">
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const code = FIPS_TO_STATE[geo.id];
              const isHQ = code === "UT";
              const isHover = hovered === code;
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  data-testid={`map-state-${code}`}
                  onMouseEnter={() => setHovered(code)}
                  onMouseLeave={() => setHovered(null)}
                  style={{
                    default: {
                      fill: isHQ ? "#1e3a6e" : isHover ? "#f2d024" : "#e8eef7",
                      stroke: "#ffffff",
                      strokeWidth: 0.75,
                      outline: "none",
                      transition: "fill 200ms",
                    },
                    hover: {
                      fill: isHQ ? "#1e3a6e" : "#f2d024",
                      outline: "none",
                      cursor: "default",
                    },
                    pressed: { outline: "none" },
                  }}
                >
                  <title>{code}{isHQ ? " — Headquarters (Taylorsville)" : ""}</title>
                </Geography>
              );
            })
          }
        </Geographies>
      </ComposableMap>
      <div className="absolute bottom-2 left-2 flex items-center gap-4 text-xs text-muted-foreground bg-background/80 backdrop-blur-sm rounded-md px-3 py-1.5 border border-border">
        <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm bg-primary inline-block" /> Headquarters — Utah</span>
        <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm inline-block" style={{ background: "#e8eef7", border: "1px solid #d4deeb" }} /> Service area</span>
      </div>
    </div>
  );
}
